import { ReactElement } from 'react'
import { theme } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import { AnalyticsStatsData } from 'types'
import { useTranslate } from 'utils'
import { CustomChartTooltip } from '../custom-chart-tooltip/custom-chart-tooltip'

type AnalyticsChartProps = {
    data: AnalyticsStatsData[]
    currencySymbol: string
}

export const AnalyticsChart = ({
    data,
    currencySymbol
}: AnalyticsChartProps): ReactElement => {
    const { __ } = useTranslate()
    const { token: { fontSizeXL, colorTextSecondary }} = theme.useToken()

    return data.length ? (
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    width={500}
                    height={300}
                    data={data.map(dataValue => ({
                        name: dataValue?.name || '',
                        sales: dataValue?.value?.sales || 0,
                        appointments: dataValue?.value?.appointments || 0
                    }))}
                    margin={{
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 50,
                    }}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="#ccc"
                        vertical={false}
                    />
                    <XAxis
                        dataKey="name"
                        strokeWidth={0}
                        tick={({x, y, payload}) => (
                            <text
                                x={x}
                                y={y + 10}
                                fill='#666'
                                fontSize='0.75rem'
                                textAnchor='end'
                                transform={`rotate(-45 ${x}, ${y + 10})`}
                            >
                                { payload.value }
                            </text>
                        )}
                    />
                    <Tooltip
                        content={<CustomChartTooltip currencySymbol={currencySymbol} />}
                        cursor={{ fill: 'transparent' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="appointments"
                        stroke="#ad8bfc"
                        strokeWidth={3}
                        dot={false}
                        activeDot={{ r: 5 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="sales"
                        stroke="#1dd9e3"
                        strokeWidth={3}
                        dot={false}
                        activeDot={{ r: 5 }}
                    />
                </LineChart>
        </ResponsiveContainer>
        ) : <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <ExclamationCircleOutlined style={{ fontSize: fontSizeXL, color: colorTextSecondary }} />
                <p style={{ color: colorTextSecondary}}>{ __`nothing_found` }</p>
        </div>
}
